import React from 'react';
import { BaasicDropdown, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

function LookupSelectTemplate({ lookupViewStore, t }) {
	if (lookupViewStore.loading && _.get(lookupViewStore, 'rootStore.viewStore.selectedModal.isOpen') == false)
		return <Loader />;
	const { selectedLookup, lookupDropdownStore } = lookupViewStore;
	return selectedLookup ? (
		<div className="header__right--lookup">
			<BaasicDropdown dropdownStore={lookupDropdownStore} isClearable={true} placeholder={t('SELECTLOOKUP')} />
		</div>
	) : null;
}

LookupSelectTemplate.propTypes = {};

export default defaultTemplate(LookupSelectTemplate);
